"use strict";

import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { FOREST_GREEN } from "../stylesheets/colors";

const MoodTrackerPage = React.createClass({
  propTypes: {
    auth: React.PropTypes.object.isRequired,
    dispatch: React.PropTypes.func.isRequired,
    trackerEntries: React.PropTypes.object.isRequired,
  },

  render() {
    return (
      <div className='container mb-4'>
        <div className='col-12 col-lg-8 offset-lg-2'>
          <div className='card my-4'>
            <div className='card-body'>
              <p className='mb-3' style={{ fontSize: "16px" }}>
                The mood tracker has moved to our new platform.{" "}
                <a
                  href='/trackers/mood'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: FOREST_GREEN, fontWeight: "bold" }}>
                  Click here to open the new Mood Tracker
                </a>
                . When finished, close the tab and click continue.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  },
});

export default connect((state) => ({
  auth: state.auth,
  trackerEntries: state.trackerEntries,
}))(MoodTrackerPage);
